module.exports = __webpack_public_path__ + "link1.mp3";